import LegalLayout, { Section } from "./LegalLayout";

export default function TermsOfServicePage() {
  return (
    <LegalLayout title="Terms of Service" testId="terms-page">
      <Section title="Agreement">
        <p>
          These Terms of Service (&quot;Terms&quot;) govern your access to teamie.ai and related
          services (&quot;teamie&quot; or the &quot;Service&quot;) operated by teamie. By using the Service,
          you agree to these Terms and our{" "}
          <a href="/privacy" className="text-teamie-accent hover:underline">
            Privacy Policy
          </a>
          .
        </p>
        <p>
          Questions:{" "}
          <a href="mailto:support@teamie.ai" className="text-teamie-accent hover:underline">
            support@teamie.ai
          </a>
        </p>
      </Section>

      <Section title="The Service">
        <p>
          teamie provides a digital twin that helps you manage work and personal tasks using
          context you provide and, with your permission, data from connected services such as
          Google Workspace. Features may change as we improve the product.
        </p>
        <p>
          The Service is provided on an early-access or beta basis while we expand access.
          We may limit availability, features, or regions at any time.
        </p>
      </Section>

      <Section title="Eligibility and accounts">
        <p>
          You must be at least 18 years old (or the age of majority in your jurisdiction) to
          use teamie. You are responsible for activity under your account and for keeping your
          login credentials secure.
        </p>
        <p>
          You must provide accurate information and comply with applicable laws when using
          the Service, including laws that apply to email, calendar, and data you access
          through connected accounts.
        </p>
      </Section>

      <Section title="Your content and connections">
        <p>
          You retain ownership of content you submit. You grant teamie a limited license to
          host, process, and display that content solely to operate and improve the Service
          for you.
        </p>
        <p>
          When you connect third-party accounts (such as Google), you confirm you have the
          right to connect them and that teamie may access data according to the permissions
          you approve.
        </p>
      </Section>

      <Section title="Acceptable use">
        <p>You agree not to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Use the Service for unlawful, harmful, or abusive purposes</li>
          <li>Impersonate others or misrepresent your affiliation</li>
          <li>Attempt to bypass security or access data you are not authorized to access</li>
          <li>Reverse engineer or scrape the Service except where permitted by law</li>
          <li>Use the Service to send spam or unsolicited bulk messages</li>
        </ul>
      </Section>

      <Section title="Third-party services">
        <p>
          teamie integrates with third-party services such as Google. Your use of those
          services is subject to their terms and policies. We are not responsible for
          third-party services.
        </p>
      </Section>

      <Section title="Disclaimers">
        <p>
          THE SERVICE IS PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; WITHOUT WARRANTIES OF ANY
          KIND, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR
          PURPOSE, AND NON-INFRINGEMENT. WE DO NOT GUARANTEE THAT THE SERVICE WILL BE
          ERROR-FREE, UNINTERRUPTED, OR THAT YOUR TWIN WILL ALWAYS BE ACCURATE.
        </p>
        <p>
          You are responsible for reviewing actions taken on your behalf and for decisions
          made using information from your twin.
        </p>
      </Section>

      <Section title="Limitation of liability">
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, FIIA AND ITS AFFILIATES WILL NOT BE LIABLE
          FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY
          LOSS OF PROFITS, DATA, OR GOODWILL, ARISING FROM YOUR USE OF THE SERVICE.
        </p>
        <p>
          OUR TOTAL LIABILITY FOR ANY CLAIM RELATING TO THE SERVICE IS LIMITED TO THE
          GREATER OF (A) THE AMOUNT YOU PAID US IN THE TWELVE MONTHS BEFORE THE CLAIM OR (B)
          ONE HUNDRED U.S. DOLLARS ($100).
        </p>
      </Section>

      <Section title="Termination">
        <p>
          You may stop using teamie at any time. We may suspend or terminate access if you
          violate these Terms or if we discontinue the Service. Sections that by nature
          should survive termination will survive.
        </p>
      </Section>

      <Section title="Changes">
        <p>
          We may update these Terms. We will post the revised Terms on this page. Material
          changes will be communicated where required. Continued use after changes constitutes
          acceptance.
        </p>
      </Section>

      <Section title="Governing law">
        <p>
          These Terms are governed by the laws of India, without regard to conflict-of-law
          rules. Courts in Bengaluru, Karnataka shall have exclusive jurisdiction, unless
          applicable law requires otherwise.
        </p>
      </Section>
    </LegalLayout>
  );
}
